<div class="container">
  <h2 style="font-weight: bold; margin-bottom: 2rem;" translate>notifications.notifications</h2>

  <ul class="nav nav-tabs nav-ul" role="tablist">
    <li class="nav-item">
      <a class="txt-color nav-link active" data-toggle="tab" href="#notifications" translate>notifications.notifications</a>
    </li>
    <li class="nav-item">
      <a class="txt-color nav-link" data-toggle="tab" href="#newNotification" translate>notifications.newNotification</a>
    </li>
  </ul>

  <div class="tab-content">

    <div style="min-height: 500px; padding: 12px;" id="notifications" class="tab-pane active"><br>
      <div *ngIf="allNotifications?.results?.length">
        <div #notificationsList class="row my-4">
          <div class="col-lg-4 col-md-6 col-sm-12 user-element" *ngFor="let notification of allNotifications.results">
            <div class="card">
              <div class="card-body">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <span class="mt-3" style="font-size: .9rem; font-weight: bold;">{{ notification.createdAt |
                    customDate}}</span>
                </div>
                <div class="my-3">
                  <ng-container *ngIf="notification.languageContents">
                    <p>
                      {{notification.languageContents.headLine}}
                    </p>
  
                    <div style="margin-top: 1rem">
                      <p style="font-size: .9rem;" *ngIf="notification.contentType === 'string'">
                        {{notification.languageContents?.content.slice(0, 100)}}...</p>
                      <img class="img-fluid" *ngIf="['image', 'gif'].includes(notification.contentType)"
                        [src]="notification.languageContents?.content" />
  
                      <video *ngIf="notification.contentType === 'video'" width="400" class="w-100" controls>
                        <source [src]="notification.languageContents.content" type="video/mp4">
                        Your browser does not support the video tag.
                      </video>
                    </div>
  
                  </ng-container>
                </div>
                <hr>
                <div class="my-3">
                  <p *ngIf="notification.target['global']">Notification is sent to everyone</p>
                  <p *ngIf="notification.target['customer']">Notification is sent to customers: <br> <span class="small">
                      {{notification.target['customer']['customerIds'].join(', ')}}
                    </span></p>
                  <p *ngIf="notification.target['client']">Notification is sent to clients: <br> <span
                      class="small">{{notification.target['client']['clientIds'].join(', ')}}</span></p>
                  <p *ngIf="notification.target['user']">Notification is sent to users: <br> <span
                      class="small">{{notification.target['user']['userIds'].join(', ')}}</span></p>
                </div>
                <hr>
                <div style="display: flex; justify-content: space-between;">
                  <p style="font-weight: bold;">Seen: {{notification.seen}}</p>
                  <p style="font-weight: bold;">Unseen: {{notification.notSeen}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div>
          <ngb-pagination [collectionSize]="allNotifications.count" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
            [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
        </div>
      </div>
    </div>

    <div style="min-height: 500px; padding: 12px;" id="newNotification" class="tab-pane fade"><br>
      <div class="mt-4">
        <div style="display: flex; gap: 1rem">
          <p translate>notifications.sendToEveryone</p>
          <div style="position: relative;" class="row">
            <div class="choose-window">
              <p translate>global.off</p>
              <label class="switch">
                <input type="checkbox" name="global" [(ngModel)]="isGlobal" (change)="handleChangeGlobal()">
                <span class="slider round"></span>
              </label>
              <p translate>global.on</p>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; align-items: center;" class="my-3">
        <span class="middle-line"></span>
        <span class="mx-2" translate>notifications.or</span>
        <span class="middle-line"></span>
      </div>
      <p class="mb-3" translate>notifications.selectWhoToSendNotification</p>
      <div class="row">
        <div *ngIf="loggedInUser.role.name === 'root' || loggedInUser.role.name === 'customer'"
          class=" col-lg-3 col-md-6 col-sm-12">
          <div>
            <h4 translate>{{loggedInUser.role.name === 'root' ? 'notifications.customer' : 'notifications.subcustomer'}}</h4>

            <div #searchContainer [ngClass]="{'active' : showCustomers}"
              class="div select-bg search-container notification-user" style="display: block;">
              <input type="text" readonly class="search"
                style="height: 44px; display: block; width: 100%; padding-left: 12px;"
                (click)=" openDropdown('customer')" name="selectedPreset" [(ngModel)]="selectedCustomerName">
              <div class="prikaz" *ngIf="showCustomers">
                <div class="backdrop" (click)="openDropdown('customer')"></div>
                <div style="z-index: 100; overflow-y: auto;">
                  <div class="divider"></div>
                  <input type="text" class="search-marke" (input)="onSearchChange($event.target.value, 'customer')"
                    placeholder="Search for a customer..." [(ngModel)]="searchText">
                  <ul>
                    <li [ngClass]="{'active': selectedCustomer?.id === customer.id}" class="nav-item"
                      *ngFor="let customer of filteredCustomers">
                      <label class="user-item w-100" (click)="onCustomerLabelSelect(customer, $event)">
                        <input type="checkbox" [checked]="selectedCustomers.includes(customer)"
                          (click)="$event.stopPropagation(); onCustomerCheckboxSelect(customer)"
                          [disabled]="isDisabled('customer')">
                        <span>
                          {{ customer.name }}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div *ngIf="loggedInUser.role.name !== 'client'" class=" col-lg-3 col-md-6 col-sm-12">
          <div>
            <h4 *ngIf="loggedInUser.role.name === 'root'">Clients</h4>
            <h4 *ngIf="loggedInUser.role.name === 'customer'" translate>{{!selectedCustomer ? 'notifications.yourClients' : 'Subcustomer
              Clients'}}</h4>

            <div #searchContainer [ngClass]="{'active' : showClients}"
              class="div select-bg search-container notification-user" style="display: block;">
              <input type="text" readonly class="search"
                style="height: 44px; display: block; width: 100%; padding-left: 12px;"
                (click)="canSelectClient() && openDropdown('client')" name="selectedPreset"
                [(ngModel)]="selectedClientName">
              <div class="prikaz" *ngIf="showClients">
                <div class="backdrop" (click)="openDropdown('client')"></div>
                <div style="z-index: 100; overflow-y: auto;">
                  <div class="divider"></div>
                  <input type="text" class="search-marke" (input)="onSearchChange($event.target.value, 'client')"
                    placeholder="Search for a client..." [(ngModel)]="searchTextClient">
                  <ul>
                    <li [ngClass]="{'active': selectedClient?.id === client.id}" class="nav-item"
                      *ngFor="let client of filteredClients">
                      <label class="user-item w-100" (click)="onClientSelect(client, $event)">
                        <input type="checkbox" [checked]="selectedClients.includes(client)"
                          (click)="$event.stopPropagation(); onClientCheckboxSelect(client)"
                          [disabled]="isDisabled('client')">
                        <span>
                          {{ client.name }}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" col-lg-3 col-md-6 col-sm-12">
          <div>
            <h4 translate>customer.users</h4>

            <div #searchContainer [ngClass]="{'active' : showUsers}"
              class="div select-bg search-container notification-user" style="display: block;">
              <input type="text" readonly class="search"
                style="height: 44px; display: block; width: 100%; padding-left: 12px;"
                (click)="canSelectUsers() && openDropdown('user')" name="selectedPreset" placeholder="Select Users...">
              <div class="prikaz" *ngIf="showUsers">
                <div class="backdrop" (click)="openDropdown('user')"></div>
                <div style="z-index: 100; overflow-y: auto;">
                  <div class="divider"></div>
                  <input type="text" class="search-marke" (input)="onSearchChange($event.target.value, 'user')"
                    placeholder="Search for a user..." [(ngModel)]="searchTextUser">
                  <ul>
                    <li class="nav-item" *ngFor="let user of filteredUsers">
                      <label class="user-item w-100">
                        <input type="checkbox" [checked]="selectedUsers.includes(user)" (click)="onUserSelect(user)"
                          [disabled]="isDisabled('user')">
                        <span>
                          {{ user.name }}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="mt-4" *ngIf="selectedCustomers.length || selectedClients.length || selectedUsers.length">
        <p style="font-size: 1.3rem;">Send notification to:</p>
        <div *ngIf="selectedCustomers.length">
          <p>Customers: <span style="font-weight: bold;">{{getFormatedNames('customer')}}</span>
        </div>
        <div *ngIf="selectedClients.length">
          <p>Clients: <span style="font-weight: bold;">{{getFormatedNames('client')}}</span></p>
        </div>
        <div *ngIf="selectedUsers.length">
          <p>Users: <span style="font-weight: bold;">{{getFormatedNames('user')}}</span></p>
        </div>
      </div>

      <!-- notification data -->
      <hr />
      <div>
        <p style="font-size: 1.5rem; margin: 1rem 0; text-align: center;" translate>notifications.fillNotificationData</p>
        <form #notificationForm="ngForm">

          <!-- push notification -->
          <div class="form-group">
            <div style="display: flex; gap: 1rem">
              <label translate>notifications.sendPushNotification</label>
              <div style="position: relative;" class="row">
                <div class="choose-window">
                  <p translate>global.off</p>
                  <label class="switch">
                    <input type="checkbox" name="sendPushNotification" [(ngModel)]="sendPushNotification">
                    <span class="slider round"></span>
                  </label>
                  <p translate>global.on</p>
                </div>
              </div>
            </div>
          </div>

          <!-- valid until -->
          <div class="form-group">
            <label translate>notifications.validUntil</label>
            <input class="form-control" type="text" placeholder="DD.MM.YYYY" name="validUntil" [(ngModel)]="inputDate"
              (blur)="validateAndConvertDate()">
          </div>

          <!-- priority -->
          <div class="form-group">
            <label translate>notifications.priority</label>
            <select class="form-control" [(ngModel)]="selectedPriority" name="priority">
              <option value="high" translate>notifications.high</option>
              <option value="normal" translate>notifications.normal</option>
              <option value="low" translate>notifications.low</option>
            </select>
          </div>

          <!-- content type -->
          <div class="form-group">
            <label translate>notifications.contentType</label>
            <select class="form-control" [(ngModel)]="contentType" name="contentType">
              <option value="string" translate>notifications.text</option>
              <option value="gif" translate>Gif</option>
              <option value="image" translate>notifications.image</option>
              <option value="video" translate>notifications.video</option>
            </select>
          </div>

          <div *ngIf="selectedCustomers.length" class="form-group">
            <div style="display: flex; gap: 1rem">
              <label translate>notifications.sendToSubcustomers</label>
              <div style="position: relative;" class="row">
                <div class="choose-window">
                  <p translate>global.off</p>
                  <label class="switch">
                    <input type="checkbox" name="isSubCustomers" ngModel />
                    <span class="slider round"></span>
                  </label>
                  <p translate>global.on</p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedCustomers.length || selectedClients.length" class="form-group">
            <div style="display: flex; gap: 1rem">
              <label translate>notifications.sendToAdmins</label>
              <div style="position: relative;" class="row">
                <div class="choose-window">
                  <p translate>global.off</p>
                  <label class="switch">
                    <input type="checkbox" name="onlyAdmins" ngModel />
                    <span class="slider round"></span>
                  </label>
                  <p translate>global.on</p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label translate>notifications.languages</label>
            <div class="card">
              <div class="card-body">
                <div *ngFor="let language of languages; let i = index" class="mb-4 border-bottom pb-4">
                  <h3 class="mb-3">Language {{ i + 1 }} <span *ngIf="language.language === 'english'">(Required)</span>
                  </h3>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <label class="w-100" translate>notifications.languages
                        <!-- <select class="form-control" [(ngModel)]="language.language" name="language{{i}}" [disabled]="language.language === 'english'"> -->
                        <!-- <option value="english">English</option>
                          <option value="spanish">Spanish</option>
                          <option value="german">German</option>
                          <option value="french">French</option>
                          <option value="italian">Italian</option>
                          <option value="hungarian">Hungarian</option>
                          <option value="catalan">Catalan</option>
                          <option value="portuguese">Portuguese</option> -->
                        <!-- </select> -->
                        <select class="form-control" [(ngModel)]="language.language" name="language{{i}}"
                          [disabled]="language.language === 'english'">
                          <option *ngFor="let lang of getAvailableLanguages(i)" [value]="lang">{{ lang }}</option>
                        </select>
                      </label>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <label class="w-100" translate>notifications.headline<input class="form-control w-100" type="text" [(ngModel)]="language.headLine" name="headLine{{i}}"/></label>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <label class="w-100" translate>notifications.shortContent<textarea class="form-control w-100" [(ngModel)]="language.shortContent" name="shortContent{{i}}"></textarea></label>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <ng-container *ngIf="contentType === 'string' || contentType === 'html'">
                        <label class="w-100" translate>notifications.content<textarea class="form-control w-100" [(ngModel)]="language.content"
                            name="content{{i}}"></textarea>
                        </label>
                      </ng-container>
                      <ng-container *ngIf="contentType === 'video' || contentType === 'gif' || contentType === 'image'">
                        <label *ngIf="language.contentType !== 'image'" translate>notifications.uploadFile
                          <input type="file" class="w-100" (change)="onFileSelected($event, i)"
                            accept="video/*, image/*, .gif" />
                        </label>
                        <div *ngIf="language.fileData" translate> File Selected: {{ language?.fileData?.name }}
                          <span class="mx-2" *ngIf="uploadedFiles.includes(i)"><i class="fa fa-check-circle"
                              style="color: #59bb1e; font-size: 1.3rem;"></i></span>
                        </div>
                      </ng-container>
                    </div>

                  </div>
                  <button *ngIf="language.language !== 'english'" class="btn btn-danger"
                    (click)="removeLanguage(i)" translate>notifications.removeLanguage</button>
                </div>
                <button class="btn btn-primary" (click)="addLanguage()" translate>notifications.addLanguage</button>
              </div>
            </div>

          </div>

          <div style="min-height: 24px;"></div>

          <button type="submit" class="custom-button" style="width: 120px;" translate
            (click)="handleSendNotification(notificationForm)" translate>global.send</button>

        </form>
      </div>
    </div>

  </div>

</div>

<div *ngIf="isUploading">
  <div *appSpinner="isUploading; message: 'File is uploading...'"></div>
</div>

<div *ngIf="isSendingNotification">
  <div *appSpinner="isSendingNotification; message: 'Sending notification...'"></div>
</div>

<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading notifications...'"></div>
</div>